import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizEnterWord } from "~modules/QuizEnterWord";

const Theme39Task1 = () => {
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Дополни предложение.'
      description='Напечатай пропущенное слово'
      successIcon='nast-2'
    >
      <QuizEnterWord
        question='Пятиэтажки прослужили дольше, чем рассчитывали архитекторы и ________.'
        answer='СТРОИТЕЛИ'
      />
    </QuizWrapper>
  );
};

export default Theme39Task1;
